
import {
  ActiveSwitches,
  InputSelector,
} from "components/picture_and_map_browser/mark_swtich_active"
import ListingsCarousel from "concepts/listings/carousel"

const DEFAULT_SELECTOR = {
  overlay:          ".cell--new-development-buildings--pictures-and-map-browser--tabbed__overlay",
  switches_anchors: ".cell--new-development-buildings--pictures-and-map-browser--tabbed__switch",
  page:             ".cell--overlay-on-page",
}


const Factory = {
  _instance: null as null | ActiveSwitches,
  instance(selector?: InputSelector){
    if (this._instance != null) {
      return this._instance
    }

    const instance = this.create(selector)
    this._instance = instance
    instance.on("switch_click", () => {
      // Fix for not auto sliding carousel after tab switched
      if (instance.getCurrentMode() === "pictures") {
        ListingsCarousel.startCycling()
      }
    })
    return this._instance
  },
  create(selector?: InputSelector){
    const merged_selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    return new ActiveSwitches(merged_selector)
  },
}

export default Factory
